import ManageFundingDepositDetails from "app/screens/ManageFundingScreen/components/ManageFundingDepositDetails/ManageFundingDepositDetails";
import type { UserType } from "app/types/userType";
import React, { Component } from "react";
import type { IntlShape } from "react-intl";
import BankDetailsDepositContent from "./components/BankDetailsDepositContent/BankDetailsDepositContent";
import BankDetailsDepositForm from "./components/BankDetailsDepositForm/BankDetailsDepositForm";
import BankDetailsDepositHeader from "./components/BankDetailsDepositHeader/BankDetailsDepositHeader";
//
type Props = {
  history: any;
  intl: IntlShape;
  user: UserType;
  currencyIsValid: any;
  I18n: any;
  deposit: (...args: Array<any>) => any;
  handleChange: (...args: Array<any>) => any;
  formSubmitted: boolean;
  otherError: string;
  amountError: string;
};

class BankDetailsDeposit extends Component<Props> {
  render(): React.ReactElement<
    React.ComponentProps<React$FragmentType>,
    React$FragmentType
  > {
    const {
      currencyIsValid,
      I18n,
      deposit,
      handleChange,
      formSubmitted,
      otherError,
      amountError,
      user,
    } = this.props;
    return (
      <React.Fragment>
        <ManageFundingDepositDetails user={user} />
        <div className="bank-wire-funding__content__bank-details">
          <BankDetailsDepositHeader user={user} />
          {currencyIsValid ? (
            <BankDetailsDepositContent user={user} />
          ) : (
            <span>No bank details available for your currency.</span>
          )}
        </div>
        {currencyIsValid && (
          <BankDetailsDepositForm
            deposit={deposit}
            I18n={I18n}
            handleChange={handleChange}
            formSubmitted={formSubmitted}
            otherError={otherError}
            amountError={amountError}
          />
        )}
      </React.Fragment>
    );
  }
}

export default BankDetailsDeposit;
